import { format } from 'date-fns';
const DATE_FORMAT = 'do MMMM yyyy';
export const date = (input) => {
    return format(input, DATE_FORMAT);
};
